import React from 'react';
import HpRewardBadge from '@hpstellar/core/visId/RewardBadge';

import withPageComponents from '../../../../page/components/with-page-components';
import SustainabilityLogo from '../../../../product/components/sustainability-logo';
import './badge-container.less';

const EMPTY_OBJ = {};

const badgeContainer = ({ productInitial, hideRewards }) => {
    const { sustainability_logo_attribute, rewardsBadge } = productInitial || EMPTY_OBJ;
    const hasRewardsLabel = rewardsBadge && rewardsBadge.label && !hideRewards;

    if (!productInitial) {
        return null;
    }

    return (
        <div className="badge-container">
            {hasRewardsLabel && (
                <HpRewardBadge
                    className="rewardsBadge"
                    label={rewardsBadge.label}
                    TooltipProps={{
                        title: rewardsBadge.tooltipTitle,
                        content: rewardsBadge.tooltipBody,
                        className: 'rewards-badge-tooltip',
                    }}
                    variation="default"
                />
            )}
            <SustainabilityLogo sustainabilityAttribute={sustainability_logo_attribute} enableTooltip={true} />
        </div>
    );
};

export default withPageComponents(badgeContainer, {
    components: ['productInitial'],
});
